var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class PossibleStatusChange {
  constructor(_data) {
    /**
     */
    __publicField(this, "IsBackwardChange");
    /**
     */
    __publicField(this, "IsEnabled");
    /**
     */
    __publicField(this, "NewStatus");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof PossibleStatusChange
     */
    __publicField(this, "$type", "V1.Cesop.Periods.StatusChanges.PossibleStatusChange");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.IsBackwardChange = _data["IsBackwardChange"];
      this.IsEnabled = _data["IsEnabled"];
      this.NewStatus = PossibleStatusChangeNewStatus[_data["NewStatus"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["IsBackwardChange"] = this.IsBackwardChange;
    _data["IsEnabled"] = this.IsEnabled;
    _data["NewStatus"] = PossibleStatusChangeNewStatus[this.NewStatus];
    return _data;
  }
}
export var PossibleStatusChangeNewStatus = /* @__PURE__ */ ((PossibleStatusChangeNewStatus2) => {
  PossibleStatusChangeNewStatus2["AwaitingData"] = "AwaitingData";
  PossibleStatusChangeNewStatus2["DataUploaded"] = "DataUploaded";
  PossibleStatusChangeNewStatus2["DocumentGenerationInProgress"] = "DocumentGenerationInProgress";
  PossibleStatusChangeNewStatus2["ReadyToSubmit"] = "ReadyToSubmit";
  PossibleStatusChangeNewStatus2["Error"] = "Error";
  PossibleStatusChangeNewStatus2["SubmittedToTa"] = "SubmittedToTa";
  PossibleStatusChangeNewStatus2["AcceptedByCesop"] = "AcceptedByCesop";
  PossibleStatusChangeNewStatus2["CorrectionNeeded"] = "CorrectionNeeded";
  PossibleStatusChangeNewStatus2["PreparingCorrection"] = "PreparingCorrection";
  return PossibleStatusChangeNewStatus2;
})(PossibleStatusChangeNewStatus || {});
